import api from './api';
import utils from '../src/mixins/utils';

export async function getSavedJobs() {
    const token = localStorage.getItem('token');

    try {
        const res = await api({
            url: `/talents/savedprojects`,
            method: 'get',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        // this.savedJobs = res.data;
        return res.data;
    } catch (err) {
        console.log(err);
    }
}

export async function getNotifications() {
    const id = localStorage.getItem('id');
    const token = localStorage.getItem('token');

    try {
        const res = await api({
            url: `/users/pusher/auth/${id}`,
            method: 'get',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return res.data;
    } catch (err) {
        console.log(err);
        // this.catchErrors(err);
    }
}

export async function convertCurrency(from, to) {
    const headers = {
        'x-rapidapi-key': process.env.RAPID_API,
        'x-rapidapi-host': process.env.RAPID_HOST,
        useQueryString: true,
    };

    try {
        const res = await axios({
            url: `https://currency-converter5.p.rapidapi.com/currency/convert?format=json&from=${from}&to=${to}&amount=1`,
            headers,
        });

        return utils.formatAmount(res.data.rates[to].rate);
    } catch (e) {
        return 0;
    }
}
